module.exports = __webpack_public_path__ + "img/yahav-signup.65ce7df2.png";